import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { ButtonWithGAClickButton, ModalHeader, Typography } from 'common/components';
import { ENTRANCE_DOORS_ELEMENT_BLOCK } from '../../../../entrance-doors-constants';

type WarmDoorProps = {
  onConsultationSignupBtnClick: () => void;
};

export const WarmDoor = ({ onConsultationSignupBtnClick }: WarmDoorProps) => (
  <>
    <ModalHeader title="Теплоизоляция и&nbsp;терморазрыв" />
    <ModalContent>
      <Typography variant="m" size="body_long">
        Теплоизоляция поддержит стабильную температуру в&nbsp;доме, а&nbsp;терморазрыв уменьшит потери тепла
        и&nbsp;улучшит шумоизоляцию.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={ENTRANCE_DOORS_ELEMENT_BLOCK}
        elementText="Оставить заявку"
        elementName="Теплоизоляция и терморазрыв"
        onClick={onConsultationSignupBtnClick}
        wide>
        Оставить заявку
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
